"use client";

/**
 * GoogleTagManager — injects the GTM loader script and noscript iframe.
 *
 * react-helmet-async requires <HelmetProvider> in a client component, which
 * conflicts with Next.js App Router's server-component root layout. next/script
 * is the correct Next.js-native equivalent and achieves the same result.
 *
 * Place <GoogleTagManager /> as the first child of <body> in layout.tsx.
 * Only loads in production; no-ops when NODE_ENV !== 'production'.
 */

import Script from "next/script";
import { defaultSEO } from "@/config/seoConfig";

export default function GoogleTagManager() {
  const gtmId = defaultSEO.googleTagManagerId;

  if (process.env.NODE_ENV !== "production" || !gtmId || gtmId === "GTM-XXXXXXX") {
    return null;
  }

  return (
    <>
      {/* GTM bootstrap */}
      <Script
        id="gtm-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `window.dataLayer = window.dataLayer || []; window.dataLayer.push({'gtm.start': new Date().getTime(), event:'gtm.js'});`,
        }}
      />

      <Script
        id="gtm-script"
        src={`https://www.googletagmanager.com/gtm.js?id=${gtmId}`}
        strategy="afterInteractive"
        async
      />

      {/* GTM noscript fallback — placed immediately inside <body> */}
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
          title="Google Tag Manager"
        />
      </noscript>
    </>
  );
}
